import styled from 'styled-components';

const StarStyled = styled.div`
  display: flex;

  > svg {
    & path {
      transition: all 0.7s ease;

      &.active {
        fill: #fad70a;
      }
    }
  }
`;

export default StarStyled;
export { StarStyled };
